import React from "react";
import { toast } from "sonner";
import { Copy, ArrowDown } from "@phosphor-icons/react";

export const TRACKING_EXAMPLE = `<script>
  // 1) Who is this visitor? Ready as soon as the page loads.
  var ctx = CustomTracking.context;
  var subId = ctx.sub_id;          // from ?sub= or ?sub_id= in your ad link
  var sessionId = ctx.session_id;  // the same on the landing and thank-you page

  // 2) Send a moment to your tracker (replace YOUR-TRACKER-DOMAIN).
  function send(eventName, c) {
    new Image().src = "https://YOUR-TRACKER-DOMAIN/postback"
      + "?event=" + eventName
      + "&sub_id=" + encodeURIComponent(c.sub_id || "")
      + "&session_id=" + encodeURIComponent(c.session_id || "");
  }

  // 3) Listen for each event.
  CustomTracking.on("form_start", function (c) { send("form_start", c); });   // first field typed in
  CustomTracking.on("lead_submit", function (c) { send("lead_submit", c); }); // lead went through
  CustomTracking.on("thank_you", function (c) { send("thank_you", c); });     // thank-you page loaded
</script>`;

// Copy-ready example of reading sub_id/session_id and hearing each event.
export function TrackingGuideCard({ onUse }) {
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(TRACKING_EXAMPLE);
      toast.success("Example copied");
    } catch (_e) {
      toast.error("Couldn't copy — select the code and copy it by hand");
    }
  };
  return (
    <div className="border border-black bg-zinc-50" data-testid="mb-tracking-guide-card">
      <div className="flex items-center gap-2 px-3 py-2 border-b border-black flex-wrap">
        <div className="font-bold text-[12px] uppercase tracking-widest">Example: read sub_id + hear every event</div>
        <div className="ml-auto flex gap-1">
          <button type="button" onClick={copy} data-testid="mb-tracking-guide-copy"
            className="border border-black bg-white px-2 py-1 text-[10px] uppercase tracking-widest hover:bg-black hover:text-white transition-colors">
            <Copy size={11} className="inline mr-1" />Copy
          </button>
          <button type="button" onClick={onUse} data-testid="mb-tracking-guide-use"
            className="border border-emerald-800 bg-emerald-800 text-white px-2 py-1 text-[10px] uppercase tracking-widest hover:bg-emerald-900 transition-colors">
            <ArrowDown size={11} className="inline mr-1" />Use this example
          </button>
        </div>
      </div>
      <pre className="font-mono text-[11px] bg-zinc-900 text-emerald-100 p-3 max-h-64 overflow-auto whitespace-pre"
        data-testid="mb-tracking-guide-code">{TRACKING_EXAMPLE}</pre>
      <div className="px-3 py-2 text-[11px] text-zinc-700 border-t border-black">
        Pick the <b>All events</b> trigger so this one code loads on the landing and thank-you pages.
        Replace <code className="font-mono">YOUR-TRACKER-DOMAIN</code> with your tracker&apos;s postback address,
        then press <b>Test my code</b>.
      </div>
    </div>
  );
}
